<script setup lang="ts">
import type { IService } from '~/components/entity/service/home-page/card/types'

const props = defineProps<IService>()

const { getPathWithLocale } = useLocalizedPath()
</script>

<template>
  <article class="ServiceHomePageCard" :class="{ 'col-span-2': props.image }">
    <header class="space-y-1">
      <NuxtLink
        :to="getPathWithLocale(props.url)"
        class="inline-block font-semibold after:absolute after:inset-0"
      >
        {{ props.heading }}
      </NuxtLink>
      <small v-if="props.description" class="block max-w-48 text-xs text-gray-600">{{
        props.description
      }}</small>
    </header>
    <NuxtImg
      v-if="props.image"
      :src="useAsset(props.image)"
      :alt="props.heading"
      width="134"
      height="134"
      format="avif,webp"
      class="pointer-events-none absolute bottom-0 right-0 size-[8.375rem]"
    />
    <footer class="mt-auto flex items-center justify-between">
      <Badge v-if="props.badge" rounded="full">{{ props.badge }}</Badge>
      <div v-if="props.icon" class="ml-auto"><UiIcon :name="props.icon" /></div>
    </footer>
  </article>
</template>

<style scoped>
.ServiceHomePageCard {
  @apply relative flex min-h-32 flex-col overflow-hidden rounded-lg border border-gray-100 bg-gray-100 p-4 text-brand-gray transition hover:border-gray-100 hover:bg-white;
}
</style>
